/**
 * Keyboard / screen-reader skip link. Visually hidden until focused,
 * then renders as a pinned pill at the top-left of the viewport.
 * Clicking it jumps focus to <main id="main">.
 *
 * Always the first focusable element on the page.
 */
export function SkipToContent() {
  return (
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:border focus:border-glass-edge focus:bg-glass-hi focus:px-4 focus:py-2 focus:text-[12px] focus:font-semibold focus:text-ink focus:shadow-[0_8px_28px_rgba(0,0,0,0.18)] focus:outline-2 focus:outline-offset-2"
      style={{ outlineColor: 'var(--color-teal)' }}
    >
      Skip to main content
    </a>
  );
}
